"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var React = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var Header_1 = __importDefault(require("./Header"));
var PlaySummary = function (props) {
    console.log("PlaySummary() ".concat(props.play.title));
    return (React.createElement(React.Fragment, null,
        React.createElement(Header_1["default"], { play_id: props.play_id, title: props.play.title, next_scene: [1, 1] }),
        React.createElement("div", { className: "play_summary" },
            React.createElement("div", null,
                React.createElement("div", null,
                    React.createElement("b", null,
                        "by ",
                        props.play.author)),
                React.createElement("div", null,
                    React.createElement(react_router_dom_1.Link, { to: "/" }, "Home"))),
            React.createElement("h3", null, "Dramatis Personae"),
            React.createElement("ul", null, props.play.dramatis_personae.map(function (part) {
                return React.createElement("li", { key: part }, part);
            })))));
};
exports["default"] = PlaySummary;
